import { cx } from '@7f-ui'
import { Skeleton } from '@7f-ui/components/skeleton/skeleton'

type Props = {
  variant?: 'wide' | 'square'
  mobileSize?: 'fixed' | 'full'
  className?: string
  count?: number
}

export function SkeletonCards({ variant = 'wide', mobileSize, className, count = 1 }: Props) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={cx(
            '@container',
            mobileSize === 'fixed' ? 'w-64 sm:size-full' : 'size-full',
            className
          )}
        >
          <div className="grid w-full @2xl:grid-cols-3 @2xl:gap-8 gap-3">
            <div
              className={cx(
                '@2xl:col-span-1 @sm:aspect-auto @2xl:min-h-0 @xl:min-h-72 min-h-0 w-full',
                variant === 'square' ? 'aspect-square @xs:min-h-64' : 'aspect-video @sm:min-h-64'
              )}
            >
              <Skeleton />
            </div>

            <div className="@2xl:col-span-2 my-auto space-y-3 @2xl:py-6 @4xl:py-12">
              <Skeleton className="@2xl:h-10 @xl:h-8 h-6" />
              <Skeleton className="@2xl:h-10 @xl:h-8 h-6 w-7/12" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
